<div class="app-dropdown-content">
  <div class="close-btn-box">
    <button class="no-style close-btn" (click)="hide()">
      <mat-icon [svgIcon]="'close'" class="square-icon close-icon"></mat-icon>
    </button>
  </div>

  <ng-content></ng-content>
</div>

<div class="app-dropdown-overlay" (click)="hide()"></div>
